// Lib
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Context
import { useComponentsPool } from '../../../../ComponentsPool';
import useWosCredentials from '../../../authentication/useWosCredentials';
// Actions
import { updateWorkspaceSetting } from '../../../core/actions';
import { EVENT_MODIFY_WORKSPACE_SETTINGS, segmentTrack } from '../../../layout/helper';
import { ConfigTabsContext } from '../../ConfigContext';

const splittedUrl = window.location.hostname.split('.');
const URL_SUFFIX = splittedUrl[splittedUrl.length - 1] === 'io' ? 'io' : 'com';

const V2Configuration = props => {
  const page = props.menuTabs.find(tab => tab.pageName === 'V2Configuration')?.subTabs[props.tabIdx]?.title.replace('configure_v2_', '');
  const iframeRef = React.useRef(null);
  const wosUrl = `https://wos.merciyanis.${URL_SUFFIX}/${page}`;
  useWosCredentials(iframeRef, wosUrl);

  return (
    <div className={'configuration-page-content'}>
      <iframe
        ref={iframeRef}
        className='devices-failures-wrapper'
        id="inlineFrameExample"
        title="Inline Frame Example"
        frameBorder="0"
        src={wosUrl}
      />

    </div>
  );
};

export default V2Configuration;
